export default {
  getPerPage: (tab) => {
    return 15
  },
  getHead: () => {
    return [
      {name: 'No.', style:{minWidth:'100px', width:'100px'}},
      {name: '회사명', key: 'field_name'},
      {name: '담당자', key: 'director_name'},
      {name: '사업장 연락처', key: 'phone'},
    ]
  } ,
  getCol: (index, row, func) => {
    try {
      switch (index) {
        // No.
        case 0: return func.no

        // 회사명
        case 1: return row.field_name || "-"

        // 담당자
        case 2: return row.director_name || "-"

        // 사업장 연락처
        case 3: return row.phone || "-"

      }
    } catch (e) { /*ignore*/ }
    return ''
  },
}
